import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { FeaturedProducts } from "@/components/FeaturedProducts";
import { Categories } from "@/components/Categories";
import { About } from "@/components/About";
import { InventorSection } from "@/components/InventorSection";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-brand-bg text-brand-text antialiased" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <FeaturedProducts />
        <Categories />
        <About />
        <InventorSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
